// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Completions_InferInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /completions/infer
 *
 * AI inference endpoint for extracting structured data from rich text content.
 */
import { registerContract } from './validate'

export interface Completions_InferInput {
richTextContent: string
jsonSchemaToFill?: unknown
extraInformationsObject?: unknown
}

registerContract('Completions_InferInput', {
  richTextContent:         { type: 'string',  required: true },
  jsonSchemaToFill:        { type: 'object',  required: false },
  extraInformationsObject: { type: 'object',  required: false },
})
